.checkbox-skeleton-old {
	& rect {
		stroke: var(--ds-border, var(--adg3-color-N40));
		stroke-width: 2px;
		fill: var(--ds-background-input, var(--adg3-color-N10));
	}
	&:hover rect {
		fill: var(--ds-surface, var(--adg3-color-N30));
	}
	&:focus {
		outline: none;
		& rect {
			stroke: var(--ds-background-input-pressed, var(--adg3-color-B100));
		}
	}
}

.checkbox-skeleton {
	& rect {
		stroke: var(--ds-icon-subtle, #626f86);
		stroke-width: 2px;
		fill: var(--ds-background-input, var(--adg3-color-N10));
	}
	&:hover rect {
		fill: var(--ds-surface, var(--adg3-color-N30));
	}
	&:focus {
		outline: none;
		& rect {
			stroke: var(--ds-background-input-pressed, var(--adg3-color-B100));
		}
	}
}
